import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, Slide } from 'react-toastify';
import ProjectDetail from '../common/ProjectDetail';
import { postRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './Opportunity.scss';
import '../common/LikeDislikeProject/LikeDislikeProject.scss';
var toastMessage = function toastMessage() {
  return /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 g-row--always"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-check-circle me-3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-sm-block"
  }, "Got it! We'll use this info to make better project recommendations."), /*#__PURE__*/React.createElement("span", {
    className: "d-block d-sm-none body-text-3"
  }, "We\u2019ll use this to make better recommendations."));
};
var Opportunity = /*#__PURE__*/function (_Component) {
  function Opportunity(props) {
    var _this;
    _classCallCheck(this, Opportunity);
    _this = _callSuper(this, Opportunity, [props]);
    _this.state = {
      isHovering: false,
      isHoveringOverLike: false,
      isHoveringOverDislike: false,
      showDetails: false,
      showReferralModal: false,
      notify: props.notify,
      liked: props.liked,
      disliked: props.disliked
    };
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleMouseOverLike = _this.handleMouseOverLike.bind(_this);
    _this.handleMouseLeaveLike = _this.handleMouseLeaveLike.bind(_this);
    _this.handleMouseOverDislike = _this.handleMouseOverDislike.bind(_this);
    _this.handleMouseLeaveDislike = _this.handleMouseLeaveDislike.bind(_this);
    _this.openDetails = _this.openDetails.bind(_this);
    _this.closeDetails = _this.closeDetails.bind(_this);
    _this.openReferralModal = _this.openReferralModal.bind(_this);
    _this.closeReferralModal = _this.closeReferralModal.bind(_this);
    _this.toggleNotification = _this.toggleNotification.bind(_this);
    _this.handleProjectRedirect = _this.handleProjectRedirect.bind(_this);
    _this.like = _this.like.bind(_this);
    _this.dislike = _this.dislike.bind(_this);
    return _this;
  }
  _inherits(Opportunity, _Component);
  return _createClass(Opportunity, [{
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        isHovering: false
      });
    }
  }, {
    key: "handleMouseOverLike",
    value: function handleMouseOverLike() {
      this.setState({
        isHoveringOverLike: true,
        isHoveringOverDislike: false
      });
    }
  }, {
    key: "handleMouseLeaveLike",
    value: function handleMouseLeaveLike() {
      this.setState({
        isHoveringOverLike: false
      });
    }
  }, {
    key: "handleMouseOverDislike",
    value: function handleMouseOverDislike() {
      this.setState({
        isHoveringOverLike: false,
        isHoveringOverDislike: true
      });
    }
  }, {
    key: "handleMouseLeaveDislike",
    value: function handleMouseLeaveDislike() {
      this.setState({
        isHoveringOverDislike: false
      });
    }
  }, {
    key: "handleProjectRedirect",
    value: function handleProjectRedirect() {
      var projectUrl = this.props.projectUrl;
      window.location.href = projectUrl;
    }
  }, {
    key: "openDetails",
    value: function openDetails() {
      var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name;
      this.setState({
        showDetails: true,
        showReferralModal: false
      });
      analyticsTrack('Opened up an Opportunity Modal', {
        location: 'Opportunities Index View',
        id: id,
        project_name: name
      });
    }
  }, {
    key: "closeDetails",
    value: function closeDetails() {
      this.setState({
        showDetails: false
      });
    }
  }, {
    key: "openReferralModal",
    value: function openReferralModal() {
      this.setState({
        showReferralModal: true,
        showDetails: false
      });
    }
  }, {
    key: "closeReferralModal",
    value: function closeReferralModal() {
      this.setState({
        showReferralModal: false
      });
    }
  }, {
    key: "toggleNotification",
    value: function toggleNotification() {
      var _this2 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        csrfToken = _this$props2.csrfToken,
        toggleNotificationUrl = _this$props2.toggleNotificationUrl;
      var notify = this.state.notify;
      return postRequest(toggleNotificationUrl, {
        project_id: id
      }, csrfToken).then(function () {
        _this2.setState({
          notify: !notify
        });
      });
    }
  }, {
    key: "like",
    value: function like() {
      var _this3 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        name = _this$props3.name,
        likePath = _this$props3.likePath,
        csrfToken = _this$props3.csrfToken;
      return postRequest(likePath, {
        project_id: id
      }, csrfToken).then(function () {
        analyticsTrack('Liked an Opportunity', {
          location: 'Opportunities Index View',
          id: id,
          project_name: name
        });
        _this3.setState({
          liked: true,
          disliked: false
        });
        toast.success(toastMessage);
      });
    }
  }, {
    key: "dislike",
    value: function dislike() {
      var _this4 = this;
      var _this$props4 = this.props,
        id = _this$props4.id,
        name = _this$props4.name,
        dislikePath = _this$props4.dislikePath,
        csrfToken = _this$props4.csrfToken;
      return postRequest(dislikePath, {
        project_id: id
      }, csrfToken).then(function () {
        analyticsTrack('Disliked an Opportunity', {
          location: 'Opportunities Index View',
          id: id,
          project_name: name
        });
        _this4.setState({
          liked: false,
          disliked: true
        });
        toast.success(toastMessage);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props5 = this.props,
        id = _this$props5.id,
        name = _this$props5.name,
        workCommitment = _this$props5.workCommitment,
        areaOfExpertises = _this$props5.areaOfExpertises,
        tags = _this$props5.tags,
        duration = _this$props5.duration,
        workLocation = _this$props5.workLocation,
        isUpcoming = _this$props5.isUpcoming,
        projectInvitationStatus = _this$props5.projectInvitationStatus,
        levels = _this$props5.levels,
        employmentType = _this$props5.employmentType,
        showProjectEmploymentType = _this$props5.showProjectEmploymentType,
        basePayHidden = _this$props5.basePayHidden,
        budgetMinimum = _this$props5.budgetMinimum,
        budgetMaximum = _this$props5.budgetMaximum;
      var _this$state = this.state,
        isHovering = _this$state.isHovering,
        notify = _this$state.notify,
        liked = _this$state.liked,
        disliked = _this$state.disliked,
        isHoveringOverLike = _this$state.isHoveringOverLike,
        isHoveringOverDislike = _this$state.isHoveringOverDislike;
      return [/*#__PURE__*/React.createElement("div", {
        className: "opportunity",
        role: "button",
        tabIndex: 0,
        key: id
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        position: "top-center",
        transition: Slide,
        autoClose: 3000,
        hideProgressBar: true,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: false,
        pauseOnHover: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "details"
      }, /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "details-hover-window",
        onMouseOver: this.handleMouseOver,
        onFocus: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
        onClick: this.handleProjectRedirect
      }, isUpcoming && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "notification pull-right fa".concat(notify ? 's' : 'r', " fa-bell"),
        onClick: function onClick() {
          return _this5.toggleNotification();
        },
        role: "button",
        tabIndex: 0
      })), /*#__PURE__*/React.createElement("div", {
        className: "info",
        onClick: isUpcoming ? this.openDetails : undefined,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(ProjectDetail, {
        key: "project-".concat(id),
        name: name,
        workCommitment: workCommitment,
        tags: areaOfExpertises.concat(tags),
        duration: duration,
        workLocation: workLocation,
        projectInvitationStatus: projectInvitationStatus,
        levels: levels,
        employmentType: employmentType,
        showProjectEmploymentType: showProjectEmploymentType,
        basePayHidden: basePayHidden,
        budgetMinimum: budgetMinimum,
        budgetMaximum: budgetMaximum
      }))), /*#__PURE__*/React.createElement("div", {
        className: "like-dislike"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-none d-sm-block"
      }, "Would you like to see more projects like this one?"), /*#__PURE__*/React.createElement("div", {
        className: "d-block d-sm-none body-text-3"
      }, "Want to see more projects like this?"), /*#__PURE__*/React.createElement("i", {
        className: "ms-2 fa".concat(liked || isHoveringOverLike ? 's' : 'r', " fa-thumbs-up fa-flip-horizontal"),
        onMouseOver: this.handleMouseOverLike,
        onFocus: this.handleMouseOverLike,
        onMouseLeave: this.handleMouseLeaveLike,
        onClick: function onClick() {
          return _this5.like();
        },
        role: "button",
        tabIndex: 0
      }), /*#__PURE__*/React.createElement("i", {
        className: "ms-2 fa".concat(disliked || isHoveringOverDislike ? 's' : 'r', " fa-thumbs-down"),
        onMouseOver: this.handleMouseOverDislike,
        onFocus: this.handleMouseOverDislike,
        onMouseLeave: this.handleMouseLeaveDislike,
        onClick: function onClick() {
          return _this5.dislike();
        },
        role: "button",
        tabIndex: 0
      })), /*#__PURE__*/React.createElement("div", {
        /* Only add margins to "View More" button if on Upcoming Opportunities tab */
        className: "actions my-2 ".concat(isUpcoming ? ' mt-3' : ''),
        onMouseOver: this.handleMouseOver,
        onFocus: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, isHovering && /*#__PURE__*/React.createElement("span", {
        onClick: this.handleProjectRedirect,
        role: "button",
        tabIndex: 0,
        className: "highlight-text float-end body-text-3 medium-weight d-none d-sm-block"
      }, "VIEW MORE"), /*#__PURE__*/React.createElement("span", {
        onClick: this.handleProjectRedirect,
        role: "button",
        tabIndex: 0,
        className: "highlight-text float-end body-text-3 medium-weight d-block d-sm-none"
      }, "VIEW MORE"))))];
    }
  }]);
}(Component);
Opportunity.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  workCommitment: PropTypes.number.isRequired,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  levels: PropTypes.arrayOf(PropTypes.string),
  projectUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  likePath: PropTypes.string.isRequired,
  dislikePath: PropTypes.string.isRequired,
  isUpcoming: PropTypes.bool,
  notify: PropTypes.bool,
  toggleNotificationUrl: PropTypes.string,
  projectInvitationStatus: PropTypes.string,
  liked: PropTypes.bool,
  disliked: PropTypes.bool,
  employmentType: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool,
  basePayHidden: PropTypes.bool,
  budgetMinimum: PropTypes.string,
  budgetMaximum: PropTypes.string
};
Opportunity.defaultProps = {
  areaOfExpertises: [],
  tags: [],
  isUpcoming: false,
  notify: false,
  toggleNotificationUrl: null,
  projectInvitationStatus: '',
  liked: false,
  disliked: false,
  showProjectEmploymentType: false,
  basePayHidden: false,
  budgetMinimum: '',
  budgetMaximum: ''
};
export default Opportunity;